import React, { useEffect, useState } from "react";
import "../alertDialog/ToastAlert.css";

export const ToastAletGlobal = ({
    visible,
    type = "info",
    title,
    message,
    duration = 6000,
    onClose
}) => {

    const [closing, setClosing] = useState(false);

    useEffect(() => {

        if (!visible) return;

        const timer = setTimeout(() => {
            handleClose();
        }, duration);

        return () => clearTimeout(timer);

    }, [visible, duration]);

    const handleClose = () => {

        if (closing) return;

        setClosing(true);

        setTimeout(() => {
            onClose();
            setClosing(false);
        }, 600);

    };

    if (!visible) return null;

    const config = {
        success: {
            icon: "fa fa-check"
        },
        error: {
            icon: "fa fa-times"
        },
        warning: {
            icon: "fa fa-exclamation"
        },
        info: {
            icon: "fa fa-info"
        }
    };

    const current = config[type];

    return (
        <div className="toast-alert-container">

            <div
                className={`toast-alert-global toast-alert-${type} ${
                    closing ? "toast-alert-out" : ""
                }`}
                style={{
                    "--toast-duration": `${duration}ms`
                }}
            >

                <div className="toast-alert-content">

                    <div className="toast-alert-icon">
                        <i className={current.icon}></i>
                    </div>

                    <div
                        className={`toast-alert-text ${
                            !title ? "toast-alert-text-no-title" : ""
                        }`}
                    >

                        {title && (
                            <div className="toast-alert-header">
                                <div className="toast-alert-title">
                                    {title}
                                </div>
                            </div>
                        )}

                        <button
                            className={`toast-alert-close ${
                                !title ? "toast-alert-close-no-title" : ""
                            }`}
                            onClick={handleClose}
                        >
                            <i className="fa fa-times"></i>
                        </button>

                        <div
                            className="toast-alert-message"
                            dangerouslySetInnerHTML={{
                                __html: message
                            }}
                        />

                    </div>

                </div>

            </div>

        </div>
    );
};